import DOMPurify from "dompurify";
import React, { useEffect, useState } from "react";
import {
  Controller,
  FieldError,
  SubmitHandler,
  useForm,
} from "react-hook-form";
import toast from "react-hot-toast";
import { FaPlus } from "react-icons/fa6";
import { MdClose, MdDelete } from "react-icons/md";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate, useParams } from "react-router-dom";
import { CourseClassInterface } from "../../api/types/types";
import { useCourseClass } from "../../api/useProducts/useCourses";
import {
  CustomButton,
  FileUploadIcon,
  FileUploadModal,
  InputField,
  Sidebar,
} from "../../components";
import { smartTrim } from "../../config/functions";
import useSingleFileUpload from "../../hook/useSingleFileUpload";
import VideoCard from "../../components/VideoCard";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";

// Form data interface
interface WorkoutFormData {
  title?: string;
  description?: string;
  order?: number;
  file?: UploadedData;
}
interface UploadedData {
  url?: string;
  file?: File | null;
}
const CoursesClass: React.FC = () => {
  const { courseId } = useParams();
  const { mutate, isPending } = useCourseClass(Number(courseId));
  const { uploadImage, isUploading } = useSingleFileUpload();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setError,
    clearErrors,
    formState: { errors },
    control,
  } = useForm<WorkoutFormData>();
  const [classList, setClassList] = useState<WorkoutFormData[]>([]);
  const [isClassList, setIsClassList] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const [uploadedData, setUploadedData] = useState<UploadedData>({});
  const handleFileUpload = (data: UploadedData) => {
    setUploadedData(data);
    console.log("Uploaded Data:", data);
  };
  const description = watch("description");

  const handleSave: SubmitHandler<WorkoutFormData> = (data) => {
    // console.log("Form Submitted", data);
    let hasError = false;
    if (description === "<p><br></p>") {
      setError("description", {
        type: "manual",
        message: "description is required",
      });
      hasError = true;
    }
    // if (!uploadedData.file && !uploadedData.url) {
    //   setError("file", {
    //     type: "manual",
    //     message: "A Video or a URL is required",
    //   });
    //   hasError = true;
    // }
    if (!hasError) {
      // @ts-ignore
      data.file = uploadedData;
      setClassList((prevList = []) => [...prevList, data]);
      reset();
      setIsClassList(false);
      setUploadedData({});
    }
  };

  const handleDelete = (idx: number) => {
    const newExercise = classList.filter((_, index) => index !== idx);
    setClassList(newExercise);
  };

  const handleSubmitExercise = async () => {
    try {
      const formattedExercises: CourseClassInterface[] = await Promise.all(
        classList.map(async (value) => {
          let imageUrl;
          if (value.file?.file) {
            imageUrl = await uploadImage(value.file.file);
          } else {
            imageUrl = value?.file?.url;
          }
          return {
            title: value?.title || "",
            order: Number(value?.order) || 0,
            description: value?.description || "",
            media: imageUrl,
          };
        })
      );
      console.log(formattedExercises);
      mutate(formattedExercises as unknown as CourseClassInterface, {
        onSuccess: (data) => {
          toast.success("Successfully created");
          navigate(`/courses`);
        },
        onError: (error: any) => {
          toast.error(error.response.data.message);
        },
      });
    } catch (error) {
      toast.error(
        "An error occurred while uploading images or processing data."
      );
    }
  };

  useEffect(() => {
    if (description === "<p><br></p>") {
      console.log("1");
      setError("description", {
        type: "manual",
        message: "description is required",
      });
    } else {
      console.log("2");
      clearErrors("description");
    }
  }, [description]);
  // useEffect(() => {
  //   if (uploadedData) {
  //     clearErrors("file");
  //   }
  // }, [uploadedData]);
  const breadcrumbItems = [
    { title: "Courses", link: "courses" },
    { title: "Add Class " },
  ];
  return (
    <Sidebar>
      <div className="mt-2">
        <CustomBreadcrumb items={breadcrumbItems} />
      </div>
      <div className="flex justify-between items-center my-2">
        <h1 className="font-medium  mb-4 text-2xl">
          Course Class{isClassList ? "" : "es"}
        </h1>
        {isClassList && (
          <CustomButton
            handleClick={() => setIsClassList(false)}
            icon={<MdClose size={22} />}
            rounded="rounded-full"
            padding="p-0"
            addclass="mt-4 ms-auto w-8 h-8"
          />
        )}
      </div>
      {!isClassList ? (
        <div>
          {classList?.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
              {classList?.map((value, idx) => {
                console.log(value, "value");
                return (
                  <div
                    key={idx}
                    className="border-2 group border-darkCyan overflow-hidden rounded-lg  relative"
                  >
                    <span
                      className="hidden group-hover:flex z-10 absolute top-0 end-0 cursor-pointer w-7 h-7  justify-center items-center rounded-bl-lg  bg-darkCyan text-white"
                      onClick={() => handleDelete(idx)}
                    >
                      <MdDelete size={20} />
                    </span>
                    <VideoCard
                      media={
                        value?.file?.file
                          ? URL.createObjectURL(value?.file?.file)
                          : value?.file?.url
                      }
                      description={value?.description || ""}
                      title={value?.title || ""}
                    />
                  </div>
                );
              })}
            </div>
          ) : (
            <div
              onClick={() => setIsClassList(true)}
              className="border-2 border-darkCyan  border-dashed rounded-lg p-3 text-center mt-4 min-h-32 flex justify-center items-center"
            >
              <CustomButton
                handleClick={() => setIsClassList(true)}
                icon={<FaPlus size={25} />}
                rounded="rounded-full"
                padding="p-0"
                addclass="mt-4  w-12 h-12"
              />
            </div>
          )}
          {classList?.length >= 1 && (
            <div>
              <CustomButton
                handleClick={() => setIsClassList(true)}
                icon={<FaPlus size={25} />}
                rounded="rounded-full"
                padding="p-0"
                addclass="mt-4 ms-auto w-12 h-12"
              />
            </div>
          )}
          <div>
            <CustomButton
              handleClick={handleSubmitExercise}
              isLoading={isPending || isUploading}
              btntext="Save"
              addclass={`mt-5 mx-auto w-1/2 ${
                classList?.length === 0 && "bg-gray-400 cursor-not-allowed"
              }`}
            />
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit(handleSave)}>
          <div>
            <div className="grid lg:grid-cols-2 grid-cols-1 gap-3 ">
              <InputField
                label="Title"
                placeholder="Enter title"
                type="text"
                register={register(`title`, {
                  required: "title are required",
                })}
                error={errors.title?.message}
              />

              <InputField
                label="order"
                placeholder="Enter order"
                type="number"
                register={register(`order`, {
                  required: "Order is required",
                  validate: (value) => {
                    // @ts-ignore
                    if (value <= 0) {
                      return "Order must be a positive number";
                    }
                    // @ts-ignore
                    if (!Number.isInteger(parseFloat(value))) {
                      return "Order must be a whole number";
                    }
                    return true;
                  },
                })}
                error={errors.order?.message}
              />
              {/* <div>
                <p className="block text-gray-700 mb-2">WorkOuts</p>
                <Controller
                  name={`workoutIds`}
                  control={control}
                  rules={{ required: "workout is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={WorkoutData?.data.map((workout) => ({
                        value: workout.id.toString(),
                        label: workout.title,
                      }))}
                      isMulti
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "44px", // Background color for the select control
                          boxShadow: "none",
                          caretColor: "#24B1B3",
                          border: "1px solid #E5E7EB",
                          borderRadius: "8px",
                          fontSize: "14px",
                          "&:focus": {
                            outline: "none !important",
                            boxShadow: "none !important",
                            borderColor: "gray !important",
                          },
                          "&:hover": { borderColor: "none !important" },
                        }),
                        placeholder: (base) => ({
                          ...base,
                          color: "rgb(148 163 184)", // Set placeholder color here
                        }),
                      }}
                      placeholder="Select workout"
                    />
                  )}
                />
                {errors && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.workoutIds?.message}
                  </p>
                )}
              </div> */}
              <div className=" mt-2">
                <p className="block text-gray-700 mb-2">Description</p>
                <Controller
                  name="description"
                  control={control}
                  rules={{ required: "description is required" }}
                  render={({ field }) => (
                    <ReactQuill
                      {...field}
                      // onChange={(value) => {
                      //   field.onChange(value);
                      // }}
                      className="quill-editor"
                      modules={{
                        toolbar: [
                          ["bold", "italic", "underline", "strike"],
                          ["blockquote", "code-block"],
                          [{ header: 1 }, { header: 2 }],
                          [{ list: "ordered" }, { list: "bullet" }],

                          [{ size: ["small", false, "large", "huge"] }],
                          [{ header: [1, 2, 3, 4, 5, 6, false] }],
                          [{ color: [] }, { background: [] }],

                          [{ align: [] }],
                          ["clean"],
                        ],
                      }}
                    />
                  )}
                />
                {errors.description && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.description.message}
                  </p>
                )}
              </div>
              <div>
                <p className="block text-gray-700 mt-2">Upload video</p>

                <div className="mt-3">
                  <div onClick={() => setModalOpen(true)}>
                    <div
                      role="button"
                      className="flex flex-col justify-center items-center min-h-52 border-[1.5px] border-dashed border-gray-400 rounded-2xl"
                    >
                      {uploadedData.url ? (
                        // Display uploaded URL if present
                        <p className="text-center text-sm text-gray-600">
                          Uploaded URL: {uploadedData.url}
                        </p>
                      ) : uploadedData.file ? (
                        // Display uploaded file if present
                        <p className="text-center text-sm text-gray-600">
                          Uploaded File: {uploadedData.file.name}
                        </p>
                      ) : (
                        // Display upload prompt if nothing is uploaded
                        <>
                          <FileUploadIcon />
                          <CustomButton btntext="Upload" addclass="mt-3" />
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {errors.file && (
                  <p className="text-red-500 text-sm mt-1">
                    {(errors.file as FieldError)?.message}
                  </p>
                )}
              </div>
            </div>
          </div>

          <CustomButton
            type="submit"
            btntext="Save"
            addclass="mt-5 mx-auto w-1/2"
          />
        </form>
      )}
      <FileUploadModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        onFileUpload={handleFileUpload}
      />{" "}
    </Sidebar>
  );
};

export default CoursesClass;
